import React from "react";

function CameraIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="128"
      height="99.555"
      viewBox="0 0 128 99.555"
    >
      <g
        id="Camera_Icon"
        data-name="Camera Icon"
        transform="translate(-1 -4.25)"
      >
        <path
          id="Path_24606"
          data-name="Path 24606"
          d="M114.778,103.806H15.222A14.24,14.24,0,0,1,1,89.583V32.694A14.24,14.24,0,0,1,15.222,18.472H30.767l1.5-4.5A14.208,14.208,0,0,1,45.757,4.25H84.238A14.2,14.2,0,0,1,97.73,13.973l1.5,4.5h15.55A14.24,14.24,0,0,1,129,32.694V89.583A14.24,14.24,0,0,1,114.778,103.806ZM15.222,27.954a4.741,4.741,0,0,0-4.741,4.741V89.583a4.741,4.741,0,0,0,4.741,4.741h99.556a4.741,4.741,0,0,0,4.741-4.741V32.694a4.741,4.741,0,0,0-4.741-4.741H99.233a9.467,9.467,0,0,1-8.993-6.485l-1.493-4.494a4.745,4.745,0,0,0-4.5-3.243H45.767a4.731,4.731,0,0,0-4.5,3.243l-1.508,4.5a9.463,9.463,0,0,1-8.993,6.481Z"
          transform="translate(0 0)"
          fill="#adbacf"
        />
        <path
          id="Path_24607"
          data-name="Path 24607"
          d="M35.074,63.4A26.074,26.074,0,1,1,61.148,37.324,26.108,26.108,0,0,1,35.074,63.4Zm0-42.667A16.593,16.593,0,1,0,51.667,37.324,16.611,16.611,0,0,0,35.074,20.731Z"
          transform="translate(29.926 26.185)"
          fill="#adbacf"
        />
        <circle
          id="Ellipse_2413"
          data-name="Ellipse 2413"
          cx="4.741"
          cy="4.741"
          r="4.741"
          transform="translate(88.704 32.694)"
          fill="#adbacf"
        />
        <path
          id="Path_24608"
          data-name="Path 24608"
          d="M12.981,4.75H5.87a2.37,2.37,0,0,0,0,4.741h7.111a2.37,2.37,0,1,0,0-4.741Z"
          transform="translate(9.352 1.87)"
        />
        <path
          id="Path_24609"
          data-name="Path 24609"
          d="M14.852,13.731H7.741a4.741,4.741,0,1,1,0-9.481h7.111a4.741,4.741,0,1,1,0,9.481ZM7.741,8.991h0Z"
          transform="translate(7.481 0)"
          fill="#adbacf"
        />
      </g>
    </svg>
  );
}

export default CameraIcon;
